import axios from 'axios';

// DELETE
// /ewosapi/v1/fieldregistration/fieldcollection/{fieldCollectionId}/welfare/{registrationId}
export const deleteFieldCollectionWelfare = async (fieldCollectionId: number, registrationId: number): Promise<number> => {
  await axios.delete<number>(`/ewosapi/v1/fieldregistration/fieldcollection/${fieldCollectionId}/welfare/${registrationId}`);
  return registrationId;
};
